import PermissionsOverview from "./PermissionsOverview";
import useTitle from "../../../config/useTitle";

const Permissions = () => {
  useTitle("Permissions");

  return <PermissionsOverview />;
};

export default Permissions;